import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { MatPaginatorIntl } from '@angular/material';
import { MatPaginatorIntlSpanish } from '../MatPaginatorIntlSpanish.component';


@Component({
	selector: 'app-paginator',
	templateUrl: './paginator.component.html',
	styleUrls: ['./paginator.component.scss'],
	providers: [
		{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlSpanish }
	]
})
export class PaginatorComponent implements OnInit {
	/** The current page index. */
	@Input() pageIndex = 0;
	/**
	 * Index of the page that was selected previously.
	 * @breaking-change 8.0.0 To be made into a required property.
	 */
	@Input() previousPageIndex?: number;
	/** The current page size */
	@Input() pageSize = 10;
	/** The current total number of items being paged */
	@Input() length = 0;

	@Input() pageSizeOptions: number[] = [10, 25, 50, 100];

	@Output() changePage: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }

	ngOnInit() { }

	_changePage($event) {
		this.changePage.emit($event);
	}
}
